import { postRequest } from '../axios';
import { IPlanResponse } from './plan.service';
export interface ILoginRequest {
  user_name: string;
  password: string;
}

export enum BillingType {
  STRIPE = 'stripe',
  MANUAL = 'manual',
}

export interface IUserInfoResponse {
  user_name: string;
  email: string;
  name: string;
  plan: IPlanResponse | null;
  pending_plan: IPlanResponse;
  current_period_end: string | null;
  billing_type: BillingType;
  is_auto_charge?: boolean;
  auto_charge_per_month?: number;
  permissions: string[];
  limits: {
    csv_export_limit: number;
  };
  additional_conversation_invoice_url: string | null;
  renewal_invoice_url: string | null;
  remaining_csv_export: number;
}

export interface ILoginResponse {
  access_token: string;
  refresh_token: string;
  agent_id: string;
  chat_settings_id: string;
  knowledge_data_store_id: string;
}

export const login = async (data: ILoginRequest) => {
  const response = await postRequest<ILoginResponse, ILoginRequest>(
    '/login',
    data,
  );
  return response;
};

export const getMe = async (): Promise<IUserInfoResponse> => {
  const response = await postRequest<IUserInfoResponse, null>('/me');
  return response;
};
